import Footer from "../../components/Footer";
import Header from "../../components/Header";
import MNCVendorServices from "../../components/Service/Subservice/mnc-vendor";

import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function MNCVendor() {
    return (
        <>
        <Header/>
        <SubServiceBanner title={"MNCs Vendor Specialisty"}/>
        <MNCVendorServices/>
        <Footer/>
        </>
       
    )
}